import { getAuthHeaders, tempMeeApi } from '~/services/api';
import {
  IGetOnsiteInterviewStatusCountApiResponse,
  IGetOnsiteInterviewStatusCountPayload,
} from '../types';

export const getOnsiteInterviewStatusCount = async (
  payload: IGetOnsiteInterviewStatusCountPayload,
): Promise<IGetOnsiteInterviewStatusCountApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetOnsiteInterviewStatusCountApiResponse>(
    `/offices/postings/${payload.jobPostingId}/onsite-interviews/count`,
    {
      headers,
    },
  );

  return response.data;
};
